import { useState } from "react";
import { FiDownload, FiFileText } from "react-icons/fi";
import {
  UPLOAD_SAMPLE_COLUMNS,
  downloadUploadSampleExcel,
} from "../../utils/uploadSampleExcel";
import "../../styles/downloadSampleExcelButton.css";

export default function DownloadSampleExcelButton({
  disabled = false,
  className = "",
  label = "Download sample Excel",
  variant = "solid",
  onDownload,
  showFieldSelect = true,
}) {
  const [changeField, setChangeField] = useState("");

  const handleClick = () => {
    if (typeof onDownload === "function") {
      onDownload(changeField);
      return;
    }
    downloadUploadSampleExcel("FastRecovery-upload-sample.xlsx", changeField);
  };

  return (
    <div className={`sample-excel-download ${className}`.trim()}>
      {showFieldSelect ? (
        <label className="sample-excel-field">
          <span className="sample-excel-field__label">Field to Change</span>
          <select
            className="sample-excel-field__select"
            value={changeField}
            onChange={(e) => setChangeField(e.target.value)}
            disabled={disabled}
            aria-label="Optional field to randomize in the sample Excel"
          >
            <option value="">None (keep sample values)</option>
            {UPLOAD_SAMPLE_COLUMNS.map((col) => (
              <option key={col} value={col}>
                {col}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      <button
        type="button"
        className={`sample-excel-btn sample-excel-btn--${variant}`}
        onClick={handleClick}
        disabled={disabled}
      >
        <span className="sample-excel-btn__icon" aria-hidden>
          <FiFileText />
        </span>
        <span className="sample-excel-btn__label">{label}</span>
        <FiDownload className="sample-excel-btn__arrow" aria-hidden />
      </button>
    </div>
  );
}
